import React from "react";
import "./Profile.css";

const Profile = () => {
  return <div className="profile">Profile</div>;
};

export default Profile;
